module.exports = __webpack_public_path__ + "static/media/picture-5@2x.ba061c49.png";